/**
 * Стили (sx) для компонентов Git-модуля.
 */
import type { SxProps, Theme } from '@mui/material';

export const pageRoot: SxProps<Theme> = {
  height: 'calc(100vh - 64px - 48px)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  margin: '-24px',
  padding: '24px',
};

export const header: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  paddingTop: 0,
  paddingBottom: 2,
  borderBottom: 1,
  borderColor: 'divider',
  gap: 2,
  flexShrink: 0,
};

export const headerTitleBox: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 1,
  flex: 1,
  minWidth: 0,
};

export const urlDisplay: SxProps<Theme> = {
  flex: 1,
  fontFamily: 'monospace',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  overflowX: 'auto',
  overflowY: 'hidden',
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold',
  width: 'max-content',
};

export const urlInput: SxProps<Theme> = {
  '& .MuiInputBase-input': {
    fontFamily: 'monospace',
    whiteSpace: 'nowrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    display: 'block',
    fontSize: '14px',
    minWidth: '500px',
  },
};

export const sidebar: SxProps<Theme> = {
  width: 300,
  borderRight: 1,
  borderColor: 'divider',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

export const sidebarContent: SxProps<Theme> = {
  padding: 2,
  borderBottom: 1,
  borderColor: 'divider',
  flexShrink: 0,
};

export const mainContent: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minHeight: 0,
};

export const fileHeader: SxProps<Theme> = {
  padding: 2,
  borderBottom: 1,
  borderColor: 'divider',
  backgroundColor: 'background.default',
  flexShrink: 0,
};

export const fileHeaderTitle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 1,
};

export const fileContentBox: SxProps<Theme> = {
  flex: 1,
  overflow: 'auto',
  padding: 2,
  minHeight: 0,
};

export const emptyState: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
};

export const debugInfo: SxProps<Theme> = {
  p: 2,
  borderBottom: 1,
  borderColor: 'divider',
  bgcolor: 'grey.50',
  flexShrink: 0,
};

export const modalBox: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 440,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: '0 12px 32px rgba(15,16,20,0.12)',
  p: 3,
  borderRadius: 2,
  outline: 'none',
};

export const tokenActiveBox: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  padding: 1.5,
  backgroundColor: 'rgba(16,185,129,0.08)',
  border: '1px solid rgba(16,185,129,0.35)',
  borderRadius: 1,
  marginBottom: 2,
  color: 'success.dark',
};
